export default __webpack_public_path__ + "static/media/ico-s3-score-high.dca50113.svg";